
import { StripeCardElement } from '@stripe/stripe-js'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StripeCardInput',
  data() {
    return {
      cardInputFocus: false,
      cardElement: null as StripeCardElement | null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.createStripCardInput()
    })
  },
  methods: {
    createStripCardInput(): void {
      if (this.$stripe) {
        const elements = this.$stripe.elements()
        const card = elements.create('card', {
          iconStyle: 'solid',
          style: {
            base: {
              iconColor: '#373c49',
              color: '#fff',
              fontWeight: 500,
              fontSize: '14px',
              fontSmoothing: 'antialiased',
              '::placeholder': {
                color: '#757575'
              }
            },
            invalid: {
              iconColor: '#D6435B',
              color: '#da5565'
            }
          }
        })
        card.mount('#card-input-container')
        card.on('focus', () => {
          this.$emit('focus')
          this.cardInputFocus = true
        })
        card.on('blur', () => {
          this.$emit('blur')
          this.cardInputFocus = false
        })

        card.on('change', (event) => this.$emit('change', event))
        this.cardElement = card
      }
    }
  }
})
